import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import SinglePage from "../PdfViewer/PdfViewer";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, IconButton, Snackbar } from "@mui/material";
import MerText from "../MerComponents/MerText";
import MerEmail from "../MerComponents/MerEmail";
import MerInteger from "../MerComponents/MerInteger";
import MerDropDown from "../MerComponents/MerDropDown";
import MerNone from "../MerComponents/MerNone";
import MerRadio from "../MerComponents/MerRadio";
import MerDate from "../MerComponents/MerDate";
import MerTime from "../MerComponents/MerTime";
import MerCheckbox from "../MerComponents/MerCheckbox";
import CloseIcon from "@mui/icons-material/Close";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { URL } from "../../constants/constant";
import {forwardAnalyticsEvent} from "../../util/sendAnalyticsEvent"
import axios from "axios"
import Divider from '@mui/material/Divider';


const Component = ({
    row,
    setOpenSnackBar,
    setMessage,
    abled,
    merData,
    setMandatoryLeft
  }) => {
    const handleChange = (id, updatedValue, questionId) => {
        const index = merData.findIndex(ques => ques._id === questionId)
        if (merData[index]["mandatory"] && updatedValue && !merData[index]["value"]) {
            setMandatoryLeft(prevVal => prevVal - 1);
        }
        if (merData[index]["mandatory"] && !updatedValue && merData[index]["value"]) {
            setMandatoryLeft(prevVal => prevVal + 1);
        }
        merData[index]["answer"] = updatedValue;
        merData[index]["value"] = updatedValue;
    };
    row["question_text"] = row.questionText
    row["question_type"] = row.questionType
    switch (row.questionType) {
        case "text":
            return <MerText info={row} handleChange={handleChange} abled={abled} />;
        case "email":
            return <MerEmail info={row} handleChange={handleChange} abled={abled} />;
        case "integer":
            return (
            <MerInteger
                info={row}
                handleChange={handleChange}
                abled={abled}
                setOpen={setOpenSnackBar}
                setMessage={setMessage}
            />
            );
        case "float":
            return (
                <MerInteger info={row} handleChange={handleChange} abled={abled} />
            );
        case "mobile_no":
            return (
                <MerInteger info={row} handleChange={handleChange} abled={abled} />
            );
        case "drop_down":
            return (
                <MerDropDown info={row} handleChange={handleChange} abled={abled} />
            );
        case "radio_button":
            return <MerRadio info={row} handleChange={handleChange} abled={abled} />;
        case "checkbox":
            return <MerCheckbox info={row} handleChange={handleChange} abled={abled} />
        case "date":
            return <MerDate info={row} handleChange={handleChange} abled={abled} />;
        case "time":
            return <MerTime info={row} handleChange={handleChange} abled={abled} />;
        case "none":
            return <MerNone info={row} />;
        default:
            return <div></div>;
    }
  };

const Form = ({
    toggle,
    caseId,
    abled,
    setAbled,
    editable,
    loggedInUser,
    setFormFilled,
    status,
    repeatCaseCount,
    preSignedUrl,
    formType
}) => {
    const [merData, setMerData] = useState([]);
    const [mandatoryLeft, setMandatoryLeft] = useState(0);
    const [mandatory, setMandatory] = useState(0);
    const [loading, setLoading] = useState(false);
    const [openSnackbar, setOpenSnackBar] = useState(false);
    const [message, setMessage] = useState();
    const [testPage, setTestPage] = useState(1);
    const [openSaveDialog, setOpenSaveDialog] = useState(false); 
    const [staticMERData, setStaticMERData] = useState({});

    const setInitialMERData = (questions) => {
        let data = {};
        for (let question of questions) {
            data[question._id] = { answer: question.answer, value: question.answer }
        }
        setStaticMERData(data);
        return;
    }

    // Snack bar related functions and variables
    const handleSnackbar = () => {
        setOpenSnackBar(true);
    };
    const handleCloseSnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSnackBar(false);
    };
    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSnackbar}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    // Fetch MER Response
    useEffect(() => {
        setLoading(true);
        var config = {
            method: "get",
            headers: {
                "Content-Type": "application/json",
            }
        };
        if (formType === "MER") {
            config["url"] = `${URL.demystify_url}mer/fetchMERresponseV2?caseId=${caseId}`
        }
        else if (formType === "Doctor") {
            config["url"] = `${URL.demystify_url}doctorForm/fetchDoctorForm?caseId=${caseId}`
        }
        axios(config)
            .then(function (response) {
                setMerData(response.data.questions);
                setInitialMERData(response.data.questions);
                setMandatoryLeft(response.data.questions.filter(item => item?.mandatory && item?.value.length).length);
                setMandatory(response.data.questions.filter(item => item?.mandatory).length);
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    }, []);
    
    const handleSaveOpen = () => {
        setOpenSaveDialog(true);
    };
    
    const handleSaveClose = () => {
        setOpenSaveDialog(false);
    };

    const handleSave = () => {
        let updates = []
        for (let question of merData) {
            if (staticMERData[question._id]["answer"] !== question.answer){
                updates.push({questionId: question._id, answer: question.answer})
            }
        }
        const payload = {
            caseId: caseId,
            updates: updates,
            user: loggedInUser
        }
        forwardAnalyticsEvent("DoctorFormSaveClicked", { caseId: caseId, currentStatus: status, repeatCaseCount: repeatCaseCount });
        var config = {
            method: "post",
            headers: {
                "Content-Type": "application/json"
            },
            data: payload
        }
        if (formType === "MER") {
            config["url"] = `${URL.demystify_url}mer/saveMERresponseV2`
        }
        else {
            config["url"] = `${URL.demystify_url}doctorForm/saveDoctorForm`
        }
        axios(config)
            .then((response) => {
                if (response.data.success === 1) {
                    setMessage(`Response saved successfully`);
                    setAbled(false);
                }
                else  {
                    setMessage(JSON.stringify(response.data))
                }
                handleSnackbar();
                handleSaveClose()
            })
            .catch((error) => {
                setMessage(`${error}`)
                handleSnackbar();
                handleSaveClose();
            })
    }

    return (
        <>
          (
            <div className="grid-container-mer">
                <div className="grid-pdf">
                    <div className="split left">
                        <SinglePage
                            reportFileType="application/pdf"
                            preSignedUrl = {preSignedUrl}
                            testPage={testPage}
                            setTestPage={setTestPage}
                        />
                    </div>
                </div>
            <div className="grid-form split right">
                {loading ? (
                <div className="mer-loader">
                    <CircularProgress />
                </div>
                ) : (
                <div className="grid-MER-right"> 
                    <Dialog open={openSaveDialog} onClose={handleSaveClose}>
                        <DialogTitle>Save the current details?</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Are you sure you want to save ?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                            variant="outlined"
                            color="secondary"
                            onClick={handleSaveClose}>
                                Cancel
                            </Button>
                            <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleSave}>
                                Save
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <div className="grid-topDiv">
                        <IconButton
                            onClick={() => {
                            setFormFilled(!mandatoryLeft);
                            toggle();
                            }}
                        >
                            <ArrowCircleLeftIcon
                                sx={{ fontSize: 40, color: "#4095f7" }}
                            />
                        </IconButton>
                    <h3>{formType === "Doctor" ? "Doctor Form" : "MER"}</h3>
                    <p>{`${mandatory - mandatoryLeft} /  ${mandatory}`}</p>
                    <div className="top-btns">
                        <IconButton
                        onClick={() => {
                            setAbled(editable && true);
                        }}
                        disabled={status==="VERIFIED"}
                        >
                        <EditOutlinedIcon color="primary" />
                        </IconButton>
                        <Button
                        variant="outlined"
                        sx={{ height: "fit-content" }}
                        onClick={handleSaveOpen}
                        disabled={status==="VERIFIED"}
                        >
                        Save
                        </Button>
                    </div>
                    </div>
                    <div className="grid-questions">
                        {merData?.map((row, index) => (<>
                        
                            <Component
                                key={index}
                                row={row}
                                setOpenSnackBar={setOpenSnackBar}
                                setMessage={setMessage}
                                abled={abled}
                                merData={merData}
                                setMandatoryLeft={setMandatoryLeft}
                                />
                            <Divider/>
                            </>
                        ))}
                    </div>
                </div>
                )}
            </div>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                action={action}
                message={message}
            />
            </div>
          )
        </>
      );
}
export default Form